import './modalCSS.scss';

type ModalProps = {
    item: any
    index?: number | null;
    onClose: () => void
}

export const DetailsModal: React.FC<ModalProps> = ({ item, index, onClose }) => {
    if (!item) return null

    return (
        <div className='overlay' >
            <div className='customModal' >
                <h3>Detalji</h3>
                <p>
                    <b>RB:</b> {index}
                </p>
                <p>
                    <b>Naziv poslovnog subjekta:</b> {item.EntityName ? item.EntityName : item.entityName ? item.entityName : JSON.parse(item.body).count !== 0 ? JSON.parse(item.body).resultList[0].businessEntityName : ''}
                </p>
                <p>
                    <b>Datum izdavanja:</b> {item.requestDateTime == null ? '' : item.requestDateTime.substring(8, 10) + '.' + item.requestDateTime.substring(5, 7) + '.' + item.requestDateTime.substring(0, 4) + '. ' + item.requestDateTime.substring(11, 19)}
                </p>
                <p>
                    <b>Broj protokola:</b> {item.issuerDocumentId == null ? '' : item.issuerDocumentId}
                </p>
                <p>
                    <b>Broj protokola podnosioca:</b> {item.requesteeDocumentId == null ? '' : item.requesteeDocumentId}
                </p>

                <p>
                    <b>Naziv podnosioca zahtjeva:</b> {item.requesteeFullName == null ? '' : item.requesteeFullName}
                </p>
                <p>
                    <b>Adresa podnosioca zahtjeva:</b> {item.address}
                </p>
                <p>
                    <b>Naplativ:</b> {item.chargible == true ? (
                        <span className='correct'>✔</span>
                    ) : (
                        <span className='incorrect'>✖</span>
                    )}

                </p>
                <p>
                    <b>Uplatioc:</b>  {item.payerName == null ? '' : item.payerName}
                </p>
                <p>
                    <b>Datum uplate:</b>  {item.payingDate == null ? '' : item.payingDate.substring(8, 10) + '.' + item.payingDate.substring(5, 7) + '.' + item.payingDate.substring(0, 4) + '.'}

                </p>
                <p>
                    <b>Korisnik radio:</b>  {item.userName == null ? '' : item.userName}

                </p>
                <p>
                    <b>Tip exporta:</b> {item.typeOfExport ? item.typeOfExport : ''}

                </p>

                <button onClick={onClose} className='myButton'>Zatvori</button>
            </div>
        </div>
    )
}
